import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { addExtraNewBankAccountId } from '@/RefundSelectionPage/BankAccountDrawer/steps/BankAccountStep/constants'

import * as Styles from './styles'

const BankAccountSelector = ({ bankAccounts = [], onChangeBankAccount, selectedAccount }) => {
  const { t } = useTranslation()

  useEffect(() => {
    if (!selectedAccount && bankAccounts.length) {
      onChangeBankAccount(bankAccounts[0])
    }
  }, [bankAccounts, onChangeBankAccount, selectedAccount])

  const changeBankAccount = e => {
    const value = e.target.value

    if (value === addExtraNewBankAccountId) {
      onChangeBankAccount({ id: addExtraNewBankAccountId })
    } else {
      onChangeBankAccount(bankAccounts.find(account => account.id === e.target.value))
    }
  }

  const bankAccountOptions = [
    ...bankAccounts.map(account => ({ label: account.number, value: account.id })),
    { label: t('Nueva cuenta'), value: addExtraNewBankAccountId },
  ]

  return (
    <Styles.Container>
      <div>
        <ComboBox
          label={t('Cuenta bancaria')}
          handleChange={changeBankAccount}
          fullWidth
          value={selectedAccount || bankAccounts[0]?.id}
          menuItems={bankAccountOptions}
        />
      </div>
    </Styles.Container>
  )
}

export default BankAccountSelector
